<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- 左侧Logo部分 -->
        <div class="footer-logo" :class="{
           'footer-logo_other': currentLanguage && !currentLanguage.startsWith('zh'),
        }">
          <img class="footer-logo-img" src="@/assets/logo.png" alt="Yacoo Logo">
          <div class="contact-info">
            <div class="contact-item" v-if="currentLanguage ==='zh'">
              <span>QQ</span> 2269920866
            </div>

            <div class="contact-item">
              <span>{{ $t('footer.contact.phone') }}</span> {{currentLanguage !=='zh'?'86-15062454963': '13451648594'}}
            </div>
            <div class="contact-item">
              <span>{{ $t('footer.contact.email') }}</span> mkt@yacoo.com.cn
            </div>
          </div>
          <div class="social-links">
            <div
              class="social-item"
              v-for="item in socialList"
              :key="item.type"
              @mouseenter="showQRCode(item.type, $event)"
              @mouseleave="hideQRCode(item.type)"
              ref="socialItem"
            >
              <img
                :src="item.icon"
                :alt="item.title"
                :title="item.title"
                class="social-icon"
              />
              <div
                class="qr-float"
                :class="['qr-float-' +item.type]"
                :data-type="item.type"
              >
                <div class="qr-container">
                  <img :src="item.qr" :alt="item.title + '二维码'" class="qr-code-img" />
                </div>
                <div class="qr-info">
                  <div class="qr-title">{{ item.title }}</div>
                  <div class="qr-tip">{{ $t('footer.qrCode.scanToFollow') }}</div>
                </div>
                <div class="qr-arrow"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧导航部分 -->
        <div class="footer-nav" :class="{
          'footer-nav_en': currentLanguage && currentLanguage.startsWith('en'),
          'footer-nav_ja': currentLanguage && currentLanguage.startsWith('ja'),
          'footer-nav_ko': currentLanguage && currentLanguage.startsWith('ko'),
          'footer-nav_ru': currentLanguage && currentLanguage.startsWith('ru'),
          'footer-nav_fr': currentLanguage && currentLanguage.startsWith('fr'),
          'footer-nav_es': currentLanguage && currentLanguage.startsWith('es'),
          'footer-nav_ar': currentLanguage && currentLanguage.startsWith('ar')
        }">
          <!-- 菜单 -->
          <template v-for="item in menuItems">
          <div class="footer-section">
            <h3>{{ item.title }}</h3>
            <ul>
              <li v-for="child in item.children" :key="child.id" @click="handleMenuClick(item,child)"
                   :class="{
                        'footer-section-li_ja': currentLanguage && currentLanguage.startsWith('ja'),
                        'footer-section-li_ko': currentLanguage && currentLanguage.startsWith('ko'),
                        'footer-section-li_ru': currentLanguage && currentLanguage.startsWith('ru'),
                        'footer-section-li_fr': currentLanguage && currentLanguage.startsWith('fr'),
                        'footer-section-li_es': currentLanguage && currentLanguage.startsWith('es')}">
                {{ child.title }}
              </li>
            </ul>
          </div>
          </template>

          <!-- 其他 -->
          <div class="footer-other">
            <h3 v-for="item in lastListRouter" :key="item.title" @click="routerPage(item)">{{ item.title }} </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bh">
      <span>{{ $t('footer.copyright') }}</span>
      <a
        class="footer-ga-link"
        href="https://beian.mps.gov.cn/#/query/webSearch?code=32059002006685"
        target="_blank"
        rel="noopener"
      >
        <img src="@/assets/images/ga.png" alt="公安备案" class="footer-ga-icon" />
        <span>苏公网安备32059002006685</span>
      </a>
    </div>
  </footer>
</template>

<script>
import { gsap } from 'gsap'
import {getMenus, getRoutes} from "@/api/menu";
import { getFootLink } from '@/api'
import {mapState} from "vuex";
import { pushWithLanguage } from '@/utils/routeUtils'

export default {
  name: 'TheFooter',

  data() {
    return {
      menuItems: [],
      friendLinks: [], // 友情链接数据
      lastListRouter: [],
      currentHoverType: null,
      activeQrElement: null,
      activeIconElement: null,
      socialList: [] // 改为响应式数据，由接口填充
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    }),

    // 社交媒体列表
    socialList() {
      return [
        {
          type: 'wechat',
          icon: require('@/assets/images/wx.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-wechat.webp',
          title: this.$t('footer.socialMedia.wechat')
        },
        {
          type: 'tiktok',
          icon: require('@/assets/images/dy.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-tiktok.webp',
          title: this.$t('footer.socialMedia.tiktok')
        },
        {
          type: 'xiaohongshu',
          icon: require('@/assets/images/xhs.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-xhs.webp',
          title: this.$t('footer.socialMedia.xiaohongshu')
        }
      ]
    }
  },

  // 添加路由监听器
  watch: {
    async currentLanguage() {
      this.initMenuCache()
      await this.getFriendLinks()
    }
  },

  created() {
    this.initMenuCache()
    this.getFriendLinks()
  },

  async mounted() {
    // 初始化GSAP动画
    this.initGSAPAnimations()
  },

  methods: {
    //获取二维码列表. socialList
    async getFriendLinks() {
      try {
        const res = await getFootLink()
        if (res.code === 200 && Array.isArray(res.data)) {
          const mapped = this.mapFootLinkData(res.data)
          this.socialList = mapped
          //存入缓存
          localStorage.setItem('socialList', JSON.stringify(mapped))
        } else {
          this.socialList = this.defaultSocialList()
        }
      } catch (error) {
        console.error('获取友情链接数据失败:', error)
        this.socialList = this.defaultSocialList()
      }
    },

    // 初始化GSAP动画
    initGSAPAnimations() {
      // 初始化时隐藏所有二维码
      this.hideAllQRCodes()
    },

    // 显示二维码
    showQRCode(type, event) {
      if (this.currentHoverType === type) return
      // 强制隐藏当前活动二维码，避免快速划过时堆叠
      this.hideActiveQRCode(true)

      this.currentHoverType = type
      const container = event.currentTarget
      const iconElement = container?.querySelector('.social-icon')
      const qrElement = container?.querySelector('.qr-float-' + type)
      if (qrElement && iconElement) {
        // 图标动画
        gsap.to(iconElement, {
          scale: 1.1,
          duration: 0.3,
          ease: "back.out(1.7)"
        })

        // 二维码显示动画
        gsap.to(qrElement, {
          opacity: 1,
          scale: 1,
          y: 0,
          duration: 0.4,
          ease: "back.out(1.7)",
          onStart: () => {
            qrElement.style.pointerEvents = 'auto'
          }
        })
        this.activeQrElement = qrElement
        this.activeIconElement = iconElement

        // 二维码内容动画
        const qrContainer = qrElement.querySelector('.qr-container')
        const qrInfo = qrElement.querySelector('.qr-info')
        const qrArrow = qrElement.querySelector('.qr-arrow')

        gsap.fromTo(qrContainer,
            {y: -10, opacity: 0},
            {y: 0, opacity: 1, duration: 0.3, delay: 0.1, ease: "power2.out"}
        )

        gsap.fromTo(qrInfo,
            {y: 10, opacity: 0},
            {y: 0, opacity: 1, duration: 0.3, delay: 0.2, ease: "power2.out"}
        )

        gsap.fromTo(qrArrow,
            {scale: 0, opacity: 0},
            {scale: 1, opacity: 1, duration: 0.2, delay: 0.3, ease: "back.out(1.7)"}
        )
      }
    },

    // 隐藏所有二维码
    hideAllQRCodes() {
      const allQRElements = document.querySelectorAll('.qr-float')
      gsap.killTweensOf(allQRElements)
      allQRElements.forEach(element => {
        gsap.set(element, {
          opacity: 0,
          scale: 0.8,
          y: 20,
          pointerEvents: 'none'
        })
      })
      const allIcons = document.querySelectorAll('.social-icon')
      gsap.killTweensOf(allIcons)
      allIcons.forEach(icon => {
        gsap.set(icon, { scale: 1 })
      })
      this.activeQrElement = null
      this.activeIconElement = null
      this.currentHoverType = null
    },

    // 隐藏二维码
    hideQRCode(type) {
      if (this.currentHoverType !== type) return
      this.hideActiveQRCode()
    },

    hideActiveQRCode(immediate = false) {
      if (!this.activeQrElement || !this.activeIconElement) {
        this.currentHoverType = null
        return
      }

      const qrElement = this.activeQrElement
      const iconElement = this.activeIconElement

      const duration = immediate ? 0 : 0.3

      gsap.killTweensOf(qrElement)
      gsap.killTweensOf(iconElement)

      gsap.to(iconElement, {
        scale: 1,
        duration,
        ease: "power2.out"
      })

      gsap.to(qrElement, {
        opacity: 0,
        scale: 0.8,
        y: 20,
        duration,
        ease: "power2.in",
        onComplete: () => {
          qrElement.style.pointerEvents = 'none'
          if (!immediate) {
            this.activeQrElement = null
            this.activeIconElement = null
          }
        }
      })

      if (immediate) {
        qrElement.style.pointerEvents = 'none'
        this.activeQrElement = null
        this.activeIconElement = null
      }

      this.currentHoverType = null
    },

    //菜单跳转
    handleMenuClick(item, child) {
      // 判断当前路由是否和目标一致
      const currentPath = this.$route.path
      const targetPath = this.generateLanguagePath(`/${item.url}/${child.url}`)

      // 先更新页面 meta 信息到缓存（store）
      try {
        const metaInfo = {
          title: child.seoTitle || child.title || '',
          keywords: child.keywords || '',
          description: child.description || ''
        }
        this.$store.commit("CHANGE_META_INFO", metaInfo)
      } catch (e) {
        console.error('更新页面 Meta 信息失败:', e)
      }

      if (currentPath === targetPath) {
        // 已经在当前页面，不做跳转
        return
      }

      // 使用 pushWithLanguage 进行跳转
      pushWithLanguage(`/${item.url}/${child.url}`, this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },

    // 页面跳转
    routerPage(item) {
      if (!item.url) {
        return
      }

      try {
        const metaInfo = {
          title: item.seoTitle || item.title || '',
          keywords: item.keywords || '',
          description: item.description || ''
        }
        this.$store.commit("CHANGE_META_INFO", metaInfo)
      } catch (e) {
        console.error('更新页面 Meta 信息失败:', e)
      }

      const currentPath = this.$route.path
      const targetPath = this.generateLanguagePath(`/${item.url}`)

      if (currentPath === targetPath) {
        // 已经在当前页面，不做跳转
        return
      }

      // 使用 pushWithLanguage 进行跳转
      pushWithLanguage(`/${item.url}`, this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },

    // 生成带语言前缀的路径
    generateLanguagePath(path) {
      const currentLang = this.currentLanguage || 'en'
      const cleanPath = path.startsWith('/') ? path : '/' + path

      // 如果路径已经包含语言前缀，直接返回
      if (cleanPath.startsWith(`/${currentLang}/`) ||
          (currentLang === 'en' && !cleanPath.startsWith('/zh/') && !cleanPath.startsWith('/ja/') && !cleanPath.startsWith('/ko/') && !cleanPath.startsWith('/ru/') && !cleanPath.startsWith('/es/') && !cleanPath.startsWith('/fr/') && !cleanPath.startsWith('/ar/'))) {
        return cleanPath
      }

      // 如果是英文，不添加语言前缀
      if (currentLang === 'en') {
        return cleanPath
      }

      // 添加语言前缀
      return `/${currentLang}${cleanPath}`
    },

    async initMenuCache() {
      try {
        const routers = await getRoutes({bottom: 1});
        if (routers.success) {
          // 动态构建菜单项
          const menuData = routers.data;
          this.menuItems = menuData.filter(item => {
            if (item.children.length > 0) {
              const menuItem = {
                ...item,
                ...{path: '/' + (item.url || item.path || '')}
              };
              // 如果有子菜单，构建二级菜单
              if (item.children && item.children.length > 0) {
                menuItem.children = item.children.map(child => ({
                  ...child,
                  ...{path: '/' + (item.url || '') + '/' + (child.url || '')} // 拼接父级url和子级url
                }));
              }
              return menuItem;
            }
          });
          this.lastListRouter = menuData.filter(e => {
            if (e.children.length === 0) return {e}
          });
          console.log(this.lastListRouter, this.menuItems, '----')
          // 将路由数据存储到本地缓存
          localStorage.setItem('menuItems', JSON.stringify(this.menuItems));
        }
      } catch (e) {
        console.error('获取菜单数据失败', e);
        // 兜底：如果接口失败，尝试读取本地缓存
        let menuItems = localStorage.getItem('menuItems');
        if (menuItems) {
          try {
            this.menuItems = JSON.parse(menuItems);
          } catch (parseError) {
            console.error('解析菜单缓存失败', parseError);
          }
        }
      }
    },


    // 将接口数据映射为组件所需结构
    mapFootLinkData(list) {
      return list.map((item, idx) => {
        const t = `type_${idx}`
        return {
          type: t,
          icon: item.icon,     // 接口字段：图标
          qr: item.qrcode,     // 接口字段：二维码
          title: item.title
        }
      })
    },

    // 接口失败时的兜底数据（与原先一致）
    defaultSocialList() {
      return [
        {
          type: 'wechat',
          icon: require('@/assets/images/wx.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-wechat.webp',
          title: this.$t('footer.socialMedia.wechat')
        },
        {
          type: 'tiktok',
          icon: require('@/assets/images/dy.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-tiktok.webp',
          title: this.$t('footer.socialMedia.tiktok')
        },
        {
          type: 'xiaohongshu',
          icon: require('@/assets/images/xhs.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-xhs.webp',
          title: this.$t('footer.socialMedia.xiaohongshu')
        }
      ]
    }
  }
}

</script>

<style lang="less" scoped>
@import '../assets/styles/variables.less';
@import '../assets/styles/mixins.less';

.footer {
  border-top: 8px solid #E26E76;
  background-color: #123769;
  padding: 130px 0 0 0;
  color: #ffffff;
  min-width: 1100px;
    .footer-bh{
      width: 100vw;
      height: 104px;
      background: rgba(255,255,255,0.05);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-weight: 600;
      font-size: @font-size-note;
      line-height: @spacing-sm;
      color: #FFFFFF;
      text-align: center;

      .footer-ga-link {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #FFFFFF;
        font-weight: 400;
        font-size: 14px;
        text-decoration: none;

        &:hover {
          color: rgba(255,255,255,0.85);
        }

        .footer-ga-icon {
          width: 20px;
          height: 20px;
        }
      }
    }
  .container {
    max-width: 1520px;
    margin: 0 auto;
    padding: 0 0 105px 0;
  }

  .footer-content {
    display: flex;
    justify-content: space-between;
  }

  .footer-logo {
    flex-shrink: 0;
    width: 280px;
    
    .footer-logo-img {
      width: 150px;
      height: auto;
      margin-bottom: 60px;
    }
    
    .contact-info {
      margin-bottom: 83px;
      
      .contact-item {
        margin-bottom: 10px;
        font-size: @font-size-note;
        color: rgba(255, 255, 255, 0.8);
        line-height: @spacing-sm;
        span {
          margin-right: 8px;
          display: inline-block;
          min-width: 40px;
        }
      }
    }
    
    .social-links {
      display: flex;
      gap: 30px;
      
      .social-item {
        position: relative;
        height: fit-content;
        width: fit-content;
        .social-icon {
          width: 40px;
          height: 40px;
          cursor: pointer;
          display: block;
        }
        .qr-float {
          position: absolute;
          left: 50%;
          top: -210px;
          /* 初始隐藏，避免动态渲染时闪现 */
          opacity: 0;
          transform: translateX(-50%) translateY(20px) scale(0.8);
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
          padding: 16px;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: center;
          pointer-events: none;
          min-width: 160px;
          
          .qr-container {
            position: relative;
            width: 120px;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            .qr-code-img {
              width: 100%;
              height: 100%;
              border-radius: 8px;
            }
          }
          
          .qr-info {
            text-align: center;
            width: 100%;
            
            .qr-title {
              font-size: @font-size-note;
              font-weight: 600;
              line-height: @spacing-sm;
              color: #333;
              margin-bottom: 4px;
            }
            
            .qr-tip {
              font-size: 12px;
              color: #666;
              margin: 0;
            }
          }
          
          .qr-arrow {
            position: absolute;
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #fff;
          }
        }
      }
    }
  }

  .footer-logo_other {
    width: 350px;
  }

  .footer-nav {
    display: flex;
    gap: 100px;
    padding-right: 200px;
  }
  .footer-nav_ru, .footer-nav_ja, .footer-nav_fr, .footer-nav_es {
    gap: 20px !important;
    padding-right: 20px !important;
  }
  .footer-nav_en {
    gap: 40px !important;
    padding-right: 20px !important;
  }
   .footer-nav_ar {
     gap: 100px;
     padding-right: 0px;
  }
  .footer-section {
    flex-shrink: 0;
    max-width: calc(100% / 4);
    h3 {
      font-size: @font-size-note;
      color: #FFFFFF;
      line-height: @spacing-sm;
      margin-bottom: 30px;

      position: relative;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 34px;
        font-size: @font-size-note;
        line-height: @spacing-sm;
        text-align: left;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: color 0.3s ease;

        &:hover {
          color: #ffffff;
        }
      }
      .footer-section-li_ru , .footer-section-li_fr {
        margin-bottom: 20px !important;
        font-size: 16px !important;
        line-height: 1.2 !important;
      }
      li:last-child {
        margin-bottom: 0;
      }
    }
  }
  .footer-other{
    flex-shrink: 0  ;
    max-width: 300px;
    h3 {
      font-size: @font-size-note;
      color: #FFFFFF;
      line-height: @spacing-sm;
      margin-bottom: 25px;

      position: relative;
      cursor: pointer;
    }
  }
}
</style> 